

import {SCOPE_TYPE} from './consts';
import {getUserInfo} from './integration';


export const getCalendarFromScope = (scope) => {
  const self = getUserInfo();
  if (self?.isCciAccount) {
    return `contact_center_${self?.accountId}@group.scheduler.zoom.us`;
  }
  if (!scope) {
    return self.calendarId;
  }
  switch (scope.type) {
    case SCOPE_TYPE.USER:
    case SCOPE_TYPE.DELEGATOR:
      return `${scope.id}@scheduler.zoom.us`;
    case SCOPE_TYPE.TEAM:
      return `team_${scope.id}@scheduler.zoom.us`;
    default:
      break;
  }
};
